import { html, css } from 'lit'
import HHQuizElement from '../element.js'
import { updateRemoteStorage } from '../store/utility-remote-storage.js'

/**
 * Quiz modal close
 * @extends HHQuizElement
 */

class HHQuizModalCloseWarning extends HHQuizElement {
  render() {
    return html`<hh-quiz-modal id="close-warning" size="sm" @modal-opened=${() => updateRemoteStorage()}>
      <div class="hh-quiz-modal-close-warning">
        <p class="body">${HH_QUIZ.t.actions.exit_quiz_confirm}</p>
        <div class="hh-quiz-modal-close-warning__actions">
          <hh-button
            width="full"
            theme="secondary"
            @keydown="${(ev) => ev.stopPropagation()}"
            @click="${() => this.store.closeQuiz()}"
            >${HH_QUIZ.t.actions.exit_quiz}</hh-button
          >
          <hh-button width="full"
            @keydown="${(ev) => ev.stopPropagation()}"
            @click="${() => this.store.closeModal()}"
            >${HH_QUIZ.t.actions.continue_quiz}</hh-button
          >
        </div>
      </div>
    </hh-quiz-modal>`
  }

  static styles = [
    HHQuizElement.styles,
    css`
      :host {
        --hh-button-padding-h: 0;
      }
      .hh-quiz-modal-close-warning {
        padding: 40px;
        display: grid;
        gap: 40px;
        text-align: center;
      }

      .hh-quiz-modal-close-warning__actions {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .hh-quiz-modal-close-warning {
          padding: 40px 20px;
        }
      }
    `,
  ]
}

customElements.define('hh-quiz-modal-close-warning', HHQuizModalCloseWarning)
